/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Ai_TitleInputs */



/**
* | output |
* | --- |
* | "AI Models & Billing" |
*
* @param {Compare_Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_ai_title = /** @type {((inputs?: Compare_Ai_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Ai_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Modelle & Abrechnung")
	return /** @type {LocalizedString} */ ("AI Models & Billing")
});